module.exports = __webpack_public_path__ + "static/media/Terras.7a930945.mp3";